import { defineMessages } from 'react-intl';

export default defineMessages({
    nextDescription: {
        id: 'ml.cancellation.common.views.submit-cancellation.We will cancel the policy next',
        defaultMessage: 'We\'ll <strong>cancel the policy</strong> next'
    },
    refundDue: {
        id: 'ml.cancellation.common.views.submit-cancellation.Refund Due',
        defaultMessage: 'Refund Due'
    },
    amountDue: {
        id: 'ml.cancellation.common.views.submit-cancellation.Amount Due',
        defaultMessage: 'Amount Due'
    },
    warningMessage1: {
        id: 'ml.cancellation.common.views.submit-cancellation.Below is the premium impact from the cancellation.',
        defaultMessage: '<strong>Below is the premium impact from the cancellation.</strong>'
    },
    warningMessage2: {
        id: 'ml.cancellation.common.views.submit-cancellation.Cancelling this policy will unbundle the remaining policy and will remove the bundle discount.',
        defaultMessage: '<strong>Cancelling this policy will unbundle the remaining policy and will remove the bundle discount.</strong>'
    },
    warningMessage2ForNP: {
        id: 'ml.cancellation.common.views.submit-cancellation.Cancelling this policy will unbundle the remaining policy.',
        defaultMessage: '<strong>Cancelling this policy will unbundle the remaining policy.</strong>'
    },
    cancelling: {
        id: 'ml.cancellation.common.config.Cancelling policy',
        defaultMessage: 'Cancelling policy'
    },
    bindErrorTitle: {
        id: 'ml.cancellation.common.config.Unable to cancel policy',
        defaultMessage: 'Unable to cancel policy'
    },
    bindErrorMessage: {
        id: 'ml.cancellation.common.config.An error occurred while cancelling the policy',
        defaultMessage: 'An error occurred while cancelling the policy'
    },
});